import { Box, Stack } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

import { IcClock } from '@/assets/images';
import { useTimer } from '@/hooks';

interface DurationCellProps {
  date: Date;
  preferred?: string;
  sx?: SxProps<Theme>;
}

export const DurationCell = ({ preferred, date, sx }: DurationCellProps) => {
  const timer = useTimer(date);
  const duration = preferred ?? timer?.duration;

  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      rowGap={4}
      sx={sx}
      className="durationContent"
    >
      <IcClock />
      <Box className="durationText">{duration}</Box>
    </Stack>
  );
};
